import { Form, Radio, Switch } from 'antd';
import { useContext } from 'react';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';
import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';

export const RoomService = () => {
  const form = Form.useFormInstance();
  const { currencyInput } = useContext(CurrencyContext);

  const isRoomServiceAvailable = Form.useWatch(
    ['isRoomServiceAvailable'],
    form
  );
  const isRoomServiceIncluded = Form.useWatch(['isRoomServiceIncluded'], form);

  return (
    <FormLineLayout label="Room service" labelOnTop>
      <Form.Item name="isRoomServiceAvailable" valuePropName="checked">
        <Switch />
      </Form.Item>
      {isRoomServiceAvailable && (
        <>
          <Form.Item name="isRoomServiceIncluded">
            <Radio.Group>
              <Radio value={true}>Free of charge</Radio>
              <Radio value={false}>Applicable fees</Radio>
            </Radio.Group>
          </Form.Item>
          {!isRoomServiceIncluded && (
            <Form.Item name="roomServicePrice">
              {currencyInput({ min: 0 })}
            </Form.Item>
          )}
        </>
      )}
    </FormLineLayout>
  );
};
